import MuiMenu, { MenuProps as MuiMenuProps } from "@mui/material/Menu";

import { TestProps } from "shared/types";

interface Props extends MuiMenuProps, TestProps {}

const Menu = ({ testId, ...props }: Props) => (
  <MuiMenu data-testid={testId} {...props} />
);

export default Menu;
